<div class="container leaderboard">
    <div class="column col-12 race-active" *ngIf="dataService.raceStarted">
        <h3>Leaderboard</h3>
        <table class="table table-striped align-content-center racer-tracking">
            <thead>
            <tr>
                <th></th>
                <th class="a-center">Racer</th>
                <th class="a-center">Bib</th>
                <th class="a-center">Laps Completed</th>
                <th class="a-center">Total Time</th>
                <th class="a-center">Lap Time</th>
                <th class="a-center">Distance</th>
                <th class="a-center">Elevation</th>
                <th class="a-center">Currently</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let racer of localRacers; let i = index">
                <td>
                    <span *ngIf="racer.profileImageUrl">
                        <img src="{{racer.profileImageUrl}}" class="racer-table-image" />
                    </span>
                    <span *ngIf="!racer.profileImageUrl">
                        <img src="{{helperService.defaultProfileImageUrl}}" class="racer-table-image" />
                    </span>
                </td>
                <td><span class="racer-name">{{racer.firstName}}<br />{{racer.lastName}}</span><br />
                    <span class="racer-location">{{racer.city}} {{racer.state}}</span>
                    <br /><span class="racer-division">{{helperService.racerDivision(racer)}}</span>
                </td>
                <td><span class="bib-icon">{{racer.backyard2023.bibNumber}}</span></td>
                <td><span class="laps-completed">
                    <span *ngIf="racer.currentPosition != 'Not Started'">{{racer.lapCount}}</span>
                    <span *ngIf="racer.currentPosition == 'Not Started'">-</span>
                </span></td>
                <td><span class="time-on-course">
                    <span *ngIf="racer.currentPosition != 'Not Started'">{{this.helperService.friendlyTimeDuration(racer.timeOnCourse, 'ms')}}</span>
                    <span *ngIf="racer.currentPosition == 'Not Started'">-</span>
                </span></td>
                <td><span class="lap-time">
                    <!--<span *ngIf="racer.currentPosition != 'Not Started'">{{this.helperService.friendlyTimeDuration((60 * 60 * 1000) - this.dataService.lapTimeRemainingMS(), 'ms')}}</span>-->
                    <span *ngIf="racer.currentPosition != 'Not Started'">{{lastLap(racer)}}</span>
                    <span *ngIf="racer.currentPosition == 'Not Started'">-</span>
                </span></td>
                <td><span class="racer-distance">
                    <span *ngIf="racer.currentPosition != 'Not Started'">{{racer.distance}}</span>
                    <span *ngIf="racer.currentPosition == 'Not Started'">-</span>
                </span></td>
                <td><span class="racer-elevation">
                    <span *ngIf="racer.currentPosition != 'Not Started'">{{racer.elevation}} ft.</span>
                    <span *ngIf="racer.currentPosition == 'Not Started'">-</span>
                </span></td>
                <td>
                    <span class="current-position">{{racer.currentPosition}}</span><br />
                    <span class="current-rank">{{helperService.friendlyRank(i)}}</span>
                </td>
            </tr>
            </tbody>
        </table>
    </div>

    <div class="column col-12 race-not-started" *ngIf="!dataService.raceStarted" style="text-align:center;">
        <h3>The WausaUltra Backyard will be starting soon.</h3>
        <p style="font-size:4em;">{{countdown}}</p>
        <h4>The WausaUltra Crew is Ready for an Epic Adventure!</h4>

    </div>
    <!--<hr />-->
    <!--<p class="note">Additional information to be presented for runners that are selected?</p>-->

</div>
